import React, { useEffect } from 'react';
import { StopCircle, User, Calendar } from 'feather-icons-react/build/IconComponents';
import Select from 'react-select';
import { useSelector, useDispatch } from 'react-redux';
import { selectProcessStatuses } from '../../core/redux/status/selectors';

import { actions as productionActions, fetchProductionsWithFilters } from './store/slice';
import { Link } from 'react-router-dom';
import { useTransformOptions } from 'Core/hooks';
import { fetchStatuses } from '../../core/redux/status/slice';

const { setProductionStatus, setProductionStartDate, setProductionEndDate } = productionActions;

const ProductionSerialFilter = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchStatuses());
  }, [dispatch]);

  const statuses = useSelector(selectProcessStatuses);
  const {
    status: selectedStatus = '',
    startDate = '',
    endDate = '',
  } = {};

  const statusOptions = useTransformOptions(statuses, 'status', 'status', '', 'Select Status');

  const handleStatusChange = selected => {
    dispatch(setProductionStatus(selected));
  };

  const onProductionSearch = () => {
    dispatch(fetchProductionsWithFilters());
  };

  return (
    <div className="card visible" id="filter_inputs" style={{ display: 'block' }}>
      <div className="card-body pb-0">
        <div className="row">
          <div className="col-lg-2 col-sm-6 col-12">
            <div className="input-blocks">
              <StopCircle className="info-img" />
              <Select
                className="img-select"
                options={statusOptions}
                value={selectedStatus}
                onChange={handleStatusChange}
                classNamePrefix="react-select"
                placeholder="Choose Status"
              />
            </div>
          </div>
          <div className="col-lg-2 col-sm-6 col-12">
            <div className="input-blocks">
              <Calendar className="info-img" />
              <input
                type="date"
                className="form-control"
                value={startDate}
                onChange={e => dispatch(setProductionStartDate(e.target.value))}
                placeholder="Start Date"
              />
            </div>
          </div>
          <div className="col-lg-2 col-sm-6 col-12">
            <div className="input-blocks">
              <Calendar className="info-img" />
              <input
                type="date"
                className="form-control"
                value={endDate}
                onChange={e => dispatch(setProductionEndDate(e.target.value))}
                placeholder="End Date"
              />
            </div>
          </div>

          <div className="col-lg-4 col-sm-6 col-12 ms-auto">
            <div className="input-blocks">
              <Link className="btn btn-filters ms-auto" onClick={onProductionSearch}>
                <i data-feather="search" className="feather-search" /> Search
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductionSerialFilter;
